import TomSelect from 'tom-select';

function changeProductMainThumbnail(image) {
  const mainThumbnail = document.getElementById('product-thumbnail');
  const imageURL = image.getAttribute('data-image');
  const imageALT = image.getAttribute('data-alt');
  mainThumbnail.setAttribute('src', imageURL);
  mainThumbnail.setAttribute('alt', imageALT);
  document
    .querySelectorAll('.product-gallery__thumbnails__thumbnail')
    .forEach(function (thumbnail) {
      thumbnail.classList.remove('active');
    });
  image.classList.add('active');
}

function updateSelectedThumbnail(formatSelect) {
  const format = document.querySelector(
    '.product-gallery__thumbnails__format[data-size="' +
      formatSelect.value +
      '"]'
  );
  if (format) {
    const thumbnail = format.querySelector(
      '.product-gallery__thumbnails__thumbnail'
    );
    changeProductMainThumbnail(thumbnail);
  }
}

function scrollToThumbnail() {
  if (768 > window.innerWidth) {
    let topScroll = 0;
    const offset = 40;
    const container = document.getElementById('product-content');

    if (container) {
      const thumbnailPosition = container.getBoundingClientRect();
      topScroll = thumbnailPosition.top - offset;
    } else {
      topScroll = offset;
    }

    window.scrollTo({ top: topScroll });
  }
}

window.addEventListener('DOMContentLoaded', function () {
  const galleryThumbnails = document.querySelectorAll(
    '.product-gallery__thumbnails__thumbnail'
  );
  const formatSelect = document.getElementById('product_sizes');
  const nutritionTabBtn = document.querySelector('.tab-nutrition');

  if (0 < galleryThumbnails.length) {
    changeProductMainThumbnail(galleryThumbnails[0]);

    galleryThumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        changeProductMainThumbnail(thumbnail);
      });
    });
  }

  if (formatSelect) {
    new TomSelect(formatSelect);
    updateSelectedThumbnail(formatSelect);
    const productUrl = formatSelect.dataset.product_url;
    formatSelect.addEventListener('change', function () {
      updateSelectedThumbnail(this);
      scrollToThumbnail();

      if (this.value) {
        const url =
          'none' === this.value ? productUrl : productUrl + this.value + '/';
        window.history.pushState('', '', url);
      }
    });
  }

  if (nutritionTabBtn) {
    nutritionTabBtn.addEventListener('click', function () {
      const selectedFormat = formatSelect.value;
      let formatThumbnail;
      let thumbnail;
      const format = document.querySelector(
        '.product-gallery__thumbnails__format[data-size="' +
          selectedFormat +
          '"]'
      );
      thumbnail = document.querySelector(
        '.product-gallery__thumbnails__thumbnail.thumbnail-nutrition'
      );
      if (format) {
        formatThumbnail = format.querySelector(
          '.product-gallery__thumbnails__thumbnail.thumbnail-nutrition'
        );
      }
      if (formatThumbnail) {
        thumbnail = formatThumbnail;
      }
      if (thumbnail) {
        changeProductMainThumbnail(thumbnail);
        scrollToThumbnail();
      }
    });
  }
});
